export const ATS = 1;
export const ServiceOTS = 2;
export const OTS = 4;